import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './auth';
import { Layout } from './components/Layout';
import { Loading } from './components/ui';
import { AccountingPage } from './pages/Accounting';
import { ArticlesPage } from './pages/Articles';
import { ProductGroupsPage } from './pages/ProductGroups';
import { RegisterPage } from './pages/Register';
import { CashClosePage } from './pages/CashClose';
import { StaffPage } from './pages/Staff';
import { ValuationPage } from './pages/Valuation';
import { BankingPage } from './pages/Banking';
import { PaymentsPage } from './pages/Payments';
import { RolesPage } from './pages/Roles';
import { BridgesPage } from './pages/Bridges';
import { AuditPage } from './pages/Audit';
import { BillingPage } from './pages/Billing';
import { BookingPage } from './pages/Booking';
import { CarriersPage } from './pages/Carriers';
import { DashboardPage } from './pages/Dashboard';
import { DocumentationPage } from './pages/Documentation';
import { ImportPage } from './pages/Import';
import { IncomingPage } from './pages/Incoming';
import { InboundPage } from './pages/Inbound';
import { InventoryPage } from './pages/Inventory';
import { LocationsPage } from './pages/Locations';
import { LabelsPage } from './pages/Labels';
import { LoginPage } from './pages/Login';
import { LotsPage } from './pages/Lots';
import { MailPage } from './pages/Mail';
import { ManagementPage } from './pages/Management';
import { OutboundPage } from './pages/Outbound';
import { PackingPage } from './pages/Packing';
import { LeadtimesPage } from './pages/Leadtimes';
import { StartPage } from './pages/Start';
import { AlertsPage } from './pages/Alerts';
import { MarginPage } from './pages/Margin';
import { AvuPage } from './pages/Avu';
import { ModulesPage } from './pages/Modules';
import { PickingPage } from './pages/Picking';
import { ReceivablesPage } from './pages/Receivables';
import { ReplenishmentPage } from './pages/Replenishment';
import { RetentionPage } from './pages/Retention';
import { ScanPage } from './pages/Scan';
import { SerialsPage } from './pages/Serials';
import { SystemPage } from './pages/System';
import { ProtocolPage } from './pages/Protocol';
import { PurchasingPage } from './pages/Purchasing';
import { ReturnsPage } from './pages/Returns';
import { SalesPage } from './pages/Sales';
import { MovementsPage } from './pages/Movements';
import { ContainerPage } from './pages/Container';
import { StandtagePage } from './pages/Standtage';
import { NeuigkeitenPage } from './pages/Neuigkeiten';
import { RueckverfolgungPage } from './pages/Rueckverfolgung';
import { FondsPage } from './pages/Fonds';
import { CockpitPage } from './pages/Cockpit';
import { PartnersPage } from './pages/Partners';
import { StockPage } from './pages/Stock';
import { UsersPage } from './pages/Users';
import { PortalPage } from './pages/Portal';

export function App() {
  const { user, ready } = useAuth();

  if (!ready) return <Loading />;
  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route element={<Layout />}>
        <Route path="/" element={<StartPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/meldungen" element={<AlertsPage />} />
        <Route path="/kalkulation" element={<MarginPage />} />
        <Route path="/avu" element={<AvuPage />} />
        <Route path="/module" element={<ModulesPage />} />
        <Route path="/bestand" element={<StockPage />} />
        <Route path="/wareneingang" element={<InboundPage />} />
        <Route path="/auftraege" element={<OutboundPage />} />
        <Route path="/bestellen" element={<PortalPage />} />
        <Route path="/warenrechnung" element={<SalesPage modus="rechnung" />} />
        <Route path="/verkaufspreise" element={<SalesPage modus="preise" />} />
        <Route path="/kommissionierung" element={<PickingPage />} />
        <Route path="/durchlaufzeiten" element={<LeadtimesPage />} />
        <Route path="/packtisch" element={<PackingPage />} />
        <Route path="/nachschub" element={<ReplenishmentPage />} />
        <Route path="/scannen" element={<ScanPage />} />
        <Route path="/chargen" element={<LotsPage />} />
        <Route path="/rueckverfolgung" element={<RueckverfolgungPage />} />
        <Route path="/seriennummern" element={<SerialsPage />} />
        <Route path="/offene-posten" element={<ReceivablesPage />} />
        <Route path="/system" element={<SystemPage />} />
        <Route path="/mailversand" element={<MailPage />} />
        <Route path="/protokoll" element={<ProtocolPage />} />
        <Route path="/betriebspruefung" element={<AuditPage />} />
        <Route path="/aufbewahrung" element={<RetentionPage />} />
        <Route path="/verfahrensdokumentation" element={<DocumentationPage />} />
        <Route path="/etiketten" element={<LabelsPage />} />
        <Route path="/import" element={<ImportPage />} />
        <Route path="/bestellungen" element={<PurchasingPage />} />
        <Route path="/rechnungseingang" element={<IncomingPage />} />
        <Route path="/retouren" element={<ReturnsPage />} />
        <Route path="/ladungstraeger" element={<CarriersPage />} />
        <Route path="/abrechnung" element={<BillingPage />} />
        <Route path="/buchhaltung" element={<AccountingPage />} />
        <Route path="/chef" element={<ManagementPage />} />
        <Route path="/buchen" element={<BookingPage />} />
        <Route path="/bewegungen" element={<MovementsPage />} />
        <Route path="/container" element={<ContainerPage />} />
        <Route path="/standtage" element={<StandtagePage />} />
        <Route path="/neuigkeiten" element={<NeuigkeitenPage />} />
        <Route path="/inventur" element={<InventoryPage />} />
        <Route path="/artikel" element={<ArticlesPage />} />
        <Route path="/partner" element={<PartnersPage />} />
        <Route path="/fonds" element={<FondsPage />} />
        <Route path="/verwaltung" element={<CockpitPage />} />
        <Route path="/lagerstruktur" element={<LocationsPage />} />
        <Route path="/warengruppen" element={<ProductGroupsPage />} />
        <Route path="/kasse" element={<RegisterPage />} />
        <Route path="/kassenabschluss" element={<CashClosePage />} />
        <Route path="/kassenpersonal" element={<StaffPage />} />
        <Route path="/lagerwert" element={<ValuationPage />} />
        <Route path="/bank" element={<BankingPage />} />
        <Route path="/zahllauf" element={<PaymentsPage />} />
        <Route path="/rollen" element={<RolesPage />} />
        <Route path="/bridges" element={<BridgesPage />} />
        <Route path="/benutzer" element={<UsersPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
